const swiper = new Swiper(".js-galleryCompany", {
    loop: true,
    centeredSlides: true,
    speed: 6000,
    allowTouchMove: false,
    slidesPerView: 2,
    autoplay: {
        delay: 0, // 途切れなくループ
    },
    breakpoints: {
		569: {
			slidesPerView: 2.5,
            speed: 4000,
		},
		769: {
			slidesPerView: 3,
		},
	}
});

//ローディング画面を取得
const loading = document.querySelector(".p-front__loading");

//ページの読み込み完了時に処理を実行
if (loading) {
    window.addEventListener("load", () => {
        document.body.classList.add("no-scroll");
        setTimeout(() => {
            loading.classList.add("loaded");
            document.querySelector('body').classList.add("loaded");
            document.body.classList.remove("no-scroll");
        }, 2000);
    });
}
